import { supabase } from '@/lib/supabase/supabaseClient';

export const deleteQuestion = async (question_id: string) => {
    return await supabase
        .from('question')
        .delete()
        .eq('id', question_id)
        .throwOnError();
}
